import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { environment } from '../../../environments/environment';

export const guestGuard: CanActivateFn = () => {
    const storage = inject(StorageService);
    const router = inject(Router);

    if (!storage.get('access_token')) {
        return true;
    }

    if (environment.appUrl) {
        window.location.href = environment.appUrl + '/dashboard';
        return false;
    }

    router.navigate(['/dashboard']);
    return false;
};
